/**
 * small wrapper for window.localStorage. Currently the wrapper mainly makes testing easier since it
 * takes care of declaring the needed variables if in a test environment.
 * @module LocalStorage
 */

if(!global.window) global.window = {};
if(!global.window.localStorage) global.window.localStorage = require('./mockedLocalStorage.jsx.js').MockedLocalStorage;

/**
 *
 * @param {sting] key
 * @returns {string | null}
 */
exports.getItem = function(key){
   return global.window.localStorage.getItem(key);
};

/**
 *
 * @param {string} key
 * @param {string} value
 */
exports.setItem = function(key, value){
   return global.window.localStorage.setItem(key, value);
};